import React from 'react';
import { Header, Button, Icon, Image } from 'semantic-ui-react';

const TopHeader = () => (
    <div className="top-header">
        <div className="header-name">
            <Button className="header-name-button" compact href="/">
                <Header size="medium" textAlign="center">
                    <Image src="/favicon/favicon-512x512_black.png" size="mini" rounded />
                    <Header.Content>Yahia Bakour</Header.Content>
                </Header>
            </Button>
        </div>
        <div className="header-links">
            <Button compact href="/about">
                About
            </Button>
            <Button compact href="/experience">
                Experience
            </Button>
            <Button compact href="/blog">
                Blog
            </Button>
        </div>
    </div>
);

export default TopHeader;
